import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Colleagues.css';

function Colleagues() {
  const cards = [
  {
  id: 'intervision',
  kicker: 'Поддержка коллег',
  title: 'Интервизионные группы',
  text:
    'Регулярные встречи для разбора кейсов, обсуждения сложностей консультирования и обмена профессиональным опытом.',
  facts: [
    'Онлайн: Google Meet / Яндекс.Телемост',
    'Понедельник, 12:00 по Томску',
    '3–8 участников',
    'Без оплаты',
  ],
  type: 'primary',
  buttonText: 'Оставить заявку',
  buttonHref:
    'https://buildin.ai/form/3393d26d-8f14-4c84-bfcb-d12e339d61d3',
  external: true,
},

  {
    id: 'supervision',
    kicker: 'Практика',
    title: 'Супервизии',
    text:
      'Групповая работа с клиническими случаями под руководством опытного супервизора. Помогает расширять профессиональное видение и получать поддержку в сложных случаях.',
    facts: [
      'Разбор реальных кейсов',
      'Подготовка случая заранее',
      'Профессиональная обратная связь',
    ],
    type: 'light',
    buttonText: 'Вступить в АПП',
    buttonHref:
      'https://www.buildin.ai/form/2ace78f6-d9c0-489a-ad37-eb801ce3772c?code=GC2JSA',
    external: true,
  },

  {
    id: 'demo',
    kicker: 'Практика',
    title: 'Демо-сессии',
    text:
      'Формат короткой учебной консультации, где один участник пробует себя в роли психолога, другой — клиента, а группа даёт конструктивную обратную связь.',
    facts: [
      'Около 25 минут',
      'Добровольное участие',
      'Групповое обсуждение после сессии',
    ],
    type: 'light',
    buttonText: 'Вступить в АПП',
    buttonHref:
      'https://www.buildin.ai/form/2ace78f6-d9c0-489a-ad37-eb801ce3772c?code=GC2JSA',
    external: true,
  },

  {
    id: 'seminars',
    kicker: 'Профессиональное сообщество',
    title: 'Открытые семинары',
    text:
      'Живое обсуждение психологических тем с практикующими специалистами. Можно задавать вопросы, получать профессиональные комментарии и предлагать темы.',
    facts: [
      'Анонсы в Telegram и ВКонтакте',
      'Открытый формат',
      'Можно предложить свою тему',
    ],
    type: 'dark',
    socialButtons: true,
  },

  {
    id: 'education',
    kicker: 'Рост и обучение',
    title: 'Обучение',
    text:
      'Образовательные программы АПП для специалистов, которые хотят системно развивать профессиональные навыки и расширять инструменты работы.',
    facts: [
      'Отдельная страница с программой',
      'Подробности о формате и темах',
      'Информация о ведущих',
    ],
    type: 'light',
    buttonText: 'Узнать больше',
    buttonHref: '/benefits/education',
    external: false,
    isRoute: true,
  },

  {
  id: 'articles',
  kicker: 'Профессиональные встречи',
  title: 'Обсуждение психологических статей',
  text:
    'Каждую среду встречаемся онлайн, читаем и обсуждаем психологические статьи разных направлений, знакомимся с новыми идеями и обмениваемся профессиональными взглядами.',
  facts: [
    'Каждую среду в 13:00',
    'Онлайн-формат',
    'Статьи разных направлений и подходов',
  ],
  type: 'primary',
  buttonText: 'Вступить в АПП',
  buttonHref:
    'https://www.buildin.ai/form/2ace78f6-d9c0-489a-ad37-eb801ce3772c?code=GC2JSA',
  external: true,
},
];



  const renderButton = (card) => {
    if (card.isRoute) {
      return (
        <Link
          to={card.buttonHref}
          className={`colleagues-card__button colleagues-card__button--${card.type}`}
        >
          {card.buttonText}
        </Link>
      );
    }

    if (card.external) {
      return (
        <a
          href={card.buttonHref}
          target="_blank"
          rel="noopener noreferrer"
          className={`colleagues-card__button colleagues-card__button--${card.type}`}
        >
          {card.buttonText}
        </a>
      );
    }

    return (
      <a
        href={card.buttonHref}
        className={`colleagues-card__button colleagues-card__button--${card.type}`}
      >
        {card.buttonText}
      </a>
    );
  };



  return (
    <main className="colleagues-page">
    <section className="colleagues-intro">
  <div className="app-container">
    <div className="colleagues-intro__simple">

      <h1>Возможности для коллег</h1>

      <p>
        Интервизии, супервизии, демо-сессии, семинары, обучение
        и участие в профессиональном сообществе АПП.
      </p>
    </div>
  </div>
</section>

{/* ВСТУПЛЕНИЕ */}
<section className="colleagues-application" id="join">
  <div className="app-container">
    <div className="colleagues-application__box">
      <h2>Подать заявку на вступление</h2>

      <p>
        Заполните короткую форму — и мы свяжемся с вами для обсуждения дальнейших шагов.
      </p>

      <a
        href="https://www.buildin.ai/form/2ace78f6-d9c0-489a-ad37-eb801ce3772c?code=GC2JSA"
        target="_blank"
        rel="noopener noreferrer"
        className="colleagues-application__button"
      >
        Вступить в АПП
      </a>
    </div>
  </div>
</section>
      <section className="colleagues-cards">
        <div className="app-container">
          <div className="colleagues-cards__grid">
            {cards.map((card) => (
              <article
                key={card.id}
                id={card.id}
                className={`colleagues-card colleagues-card--${card.type}`}
              >
                <span className="colleagues-card__kicker">{card.kicker}</span>
                <h2>{card.title}</h2>
                <p className="colleagues-card__text">{card.text}</p>

                <ul className="colleagues-card__facts">
                  {card.facts.map((fact) => (
                    <li key={fact}>{fact}</li>
                  ))}
                </ul>

                <div className="colleagues-card__footer">
                 {card.socialButtons ? (
  <div className="colleagues-card__socials">
    <a
      href="https://t.me/spp_psy_tomsk"
      target="_blank"
      rel="noopener noreferrer"
      className="colleagues-card__social-button"
    >
      Telegram
    </a>

    <a
      href="https://vk.ru/spp_psy_tomsk"
      target="_blank"
      rel="noopener noreferrer"
      className="colleagues-card__social-button"
    >
      ВКонтакте
    </a>
  </div>
) : (
  renderButton(card)
)}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      




      <section className="colleagues-home">
        <div className="app-container">
          <div className="colleagues-home__inner">
            <Link to="/" className="colleagues-home__button">
              На главную
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Colleagues;